var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (! _vm.disabled)?_c('v-content',[_c('PageHeader',{attrs:{"title":_vm.__('company.views.reports.index.title')}}),_c('Tabs',{attrs:{"tabs":_vm.tabs}})],1):_vm._e()}
var staticRenderFns = []

export { render, staticRenderFns }